/**
 * Text — mirrors aidea.templateengine/src/slides/components/Text
 *
 * role: 'body' | 'caption' | 'large'
 * align: 'left' | 'center' | 'right'
 */
import React from "react";

/* eslint-disable react/prop-types */

const ROLE_STYLES = {
  body: {
    fontSize: "var(--text-base)",
    color: "var(--color-text-secondary)",
    lineHeight: 1.6,
  },
  caption: {
    fontSize: "var(--text-sm)",
    color: "var(--color-text-muted)",
    lineHeight: 1.5,
  },
  large: {
    fontSize: "var(--text-md)",
    color: "var(--color-text-secondary)",
    lineHeight: 1.5,
  },
};

export function Text({ children, role = "body", align = "left", style }) {
  return (
    <p
      className={`atomic-text atomic-text--${role}`}
      style={{
        fontFamily: "var(--font-body)",
        margin: 0,
        textAlign: align,
        ...ROLE_STYLES[role],
        ...style,
      }}
    >
      {children}
    </p>
  );
}

export default Text;
